import { render, staticRenderFns } from "./DownloadCategoryForm.vue?vue&type=template&id=a031ca76&"
import script from "./DownloadCategoryForm.vue?vue&type=script&lang=js&"
export * from "./DownloadCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports